import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import Button from '../button/Button';
import ModalQuestion from '../modal/ModalQuestion';

import {route} from '../../../helper/Route';

class FooterCrud extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            href: ''
        }
    }

    showComponent() {
        if(this.props.componentFooterCrud === undefined)
            return ;

        return this.props.componentFooterCrud();
    } 

    showButtonSalvar() {
        if(this.props.onSalvar === undefined)        
            return ;

        if(!this.props.salvarVisible)
            return ;
        
        if(this.props.onSalvar === 'submit')    
            return (        
                <Button 
                    className="btn btn-primary"
                    type="submit"
                    background={3}
                    style={{width: '100%'}}
                    disabled={this.props.salvar.disabled}
                >
                    {this.props.salvar.name}
                </Button>
            )        

        return (
            <Button 
                className="btn btn-primary"
                type="button" 
                background={3}
                style={{width: '100%'}}
                onClick={() => {this.props.onSalvar()}}
                disabled={this.props.salvar.disabled}
            >
                {this.props.salvar.name}
            </Button>
        );
    }

    btnSimClick() {               
        if(this.props.history === undefined) {
            this.homePage2();

            return;
        }        

        return this.props.route(route(
            '',
            '',
            this.props.history
        ));        
    }    

    onCancelarClick() {        
        if(this.props.salvar === undefined)
            return this.btnSimClick();
            
        if(this.props.salvar.disabled)
            return this.btnSimClick();

        this.setState({show: !this.props.salvar.disabled});
    }

    render() {        
        return (
            <footer className="py-4 bg-light mt-auto">
                <ModalQuestion
                    show={this.state.show}
                    header="Pergunta"
                    texto="Tem certeza de que deseja sair?"
                    buttonSimTxt="Sim"
                    buttonNaoTxt="Não"

                    fechar={() => this.setState({show: false})}
                    btnSimClick={() => this.btnSimClick()}
                    btnNaoClick={() => this.setState({show: false})}
                />

                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between small">
                        <div 
                            className="col-md-7                                 
                                       col-sm-7                                                
                                       col-lg-7                                                
                                       col-xs-12
                                       text-muted"
                            style={{
                                paddingLeft: '0px',
                                paddingRight: '0px'
                            }}
                        >
                            Copyright &copy; Avance Sistemas e Consultoria 2020
                        </div>

                        <div 
                            className="col-md-5                                 
                                       col-sm-5                                                
                                       col-lg-5                                                
                                       col-xs-12"
                            style={{
                                paddingRight: '0px'
                            }}
                        >
                            <div className="col-md-3                                 
                                            col-sm-3                                                
                                            col-lg-3                                                
                                            col-xs-12">
                                        
                            </div>
                            
                            <div 
                                className="col-md-3                                 
                                           col-sm-3                                                
                                           col-lg-3                                                
                                           col-xs-12"                                
                            >
                                {this.showComponent()}
                            </div>

                            <div 
                                className="col-md-3                                 
                                           col-sm-3                                                
                                           col-lg-3                                                
                                           col-xs-12"
                                style={{paddingLeft: '0px'}}
                            >
                                {this.showButtonSalvar()}
                            </div>                            

                            <div 
                                className="col-md-3                                 
                                           col-sm-3                                                
                                           col-lg-3                                                
                                           col-xs-12"
                                style={{paddingLeft: '0px', paddingRight: '0px'}}
                            >
                                <Button 
                                    className="btn btn-light"
                                    type="button" 
                                    background={3}
                                    style={{width: '100%'}}
                                    onClick={() => this.onCancelarClick()}
                                >
                                    <i className="fa fa-arrow-left"></i> &nbsp; Voltar
                                </Button>                            
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

FooterCrud.defaultProps = {
    classNameButton: '',
    disabled: true,
    salvarVisible: true
}

export default FooterCrud;